import { useEffect, useState } from "react";

function useInsideIframe() {
  const [insideIframe, setInsideIframe] = useState(false);

  useEffect(() => {
    try {
      const inIframe = window.self !== window.top;
      if (inIframe) {
        document.body.classList.add("no-scrollbar");
      }
      setInsideIframe(inIframe);
    } catch (e) {
      document.body.classList.add("no-scrollbar");
      setInsideIframe(true);
    }
  }, []);

  return insideIframe;
}

export default useInsideIframe;
